export const catFoodData = [
    {
        id: 1,
        imageUrl:'https://res.cloudinary.com/dvjbswt50/image/upload/v1717390254/spc/DroolsOceanFishAdultCatFood_7kg_02f6fcff-239b-4d90-acd9-43cee9fa176e_dfppgk.webp',
        description: 'Drools Ocean Fish Adult Cat Dry Food - 7Kg',
    },
    {
        id: 2,
        imageUrl:'https://res.cloudinary.com/dvjbswt50/image/upload/v1717390502/spc/shopping_7_t0vhxv.webp',
        description: 'Royal Canin Persian Adult Dry Cat Food, Meat Flavor 4 Kg',
    },
    {
        id: 3,
        imageUrl:'https://res.cloudinary.com/dvjbswt50/image/upload/v1717390758/spc/shopping_8_uyahhd.webp',
        description: 'Drools Ocean Fish Adult Cat Dry Food - 20Kg',
    },
    {
        id: 4,
        imageUrl:'https://res.cloudinary.com/dvjbswt50/image/upload/v1717390964/spc/shopping_9_nw5gd3.webp',
        description: 'Drools Tuna & Salmon Adult Dry Cat Food - 3Kg',
    },
];